export function checkEmail(value) {
  return value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
}

export function checkRequired(value) {
  return !!value;
}

export function checkMinLength(value, length) {
  return value && value.length >= length;
}

export function checkFalselyRequired(value) {
  let valid = !!value;
  if (value === 0) { 
    valid = true;
  }
  return valid;
}

export function checkFalselyValue(name) {
  if (name === '') {
    name = '0';
  } else if (name === null) {
    name = '';
  }
  return name;
}



// WEBPACK FOOTER //
// ./src/shared/helpers/validators.js